// States provided by the loader class
export enum LoaderState {
	LOADING,
	IDLE,
	SUCCESS,
	ERROR
}
